import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { siteConfig } from '../data/mockData';
import { trackPhoneClick, trackEmailClick } from '../lib/analytics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-50 border-t border-neutral-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/logo.png" 
                alt="DK Soins" 
                className="h-10 w-auto"
              />
              <span className="font-semibold text-neutral-800">
                DK Soins
              </span>
            </div>
            <p className="text-sm text-neutral-600 leading-relaxed">
              Soins infirmiers professionnels à domicile pour Fleurus, Sambreville et Farciennes.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-neutral-800 mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/soins" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors">
                  Soins infirmiers
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/zone" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors">
                  Zone d'intervention
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-neutral-800 mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${siteConfig.phone}`}
                  onClick={trackPhoneClick}
                  className="flex items-start space-x-2 text-sm text-neutral-600 hover:text-amber-700 transition-colors"
                >
                  <Phone className="h-4 w-4 mt-0.5 flex-shrink-0" />
                  <span>{siteConfig.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${siteConfig.email}`}
                  onClick={trackEmailClick}
                  className="flex items-start space-x-2 text-sm text-neutral-600 hover:text-amber-700 transition-colors"
                >
                  <Mail className="h-4 w-4 mt-0.5 flex-shrink-0" />
                  <span>{siteConfig.email}</span>
                </a>
              </li>
              <li className="flex items-start space-x-2 text-sm text-neutral-600">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>{siteConfig.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-neutral-200">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-neutral-600">
              © {currentYear} Infirmière à domicile. Tous droits réservés.
            </p>
            <div className="flex items-center space-x-6 text-sm text-neutral-600">
              <span>Conventionnée INAMI</span>
              <span>•</span>
              <span>Secret professionnel</span>
              <span>•</span>
              <span>RGPD</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
